import React from 'react';

const About = () => {
  return (
    <div>
      <h1>About Route Logic</h1>
      <p>We specialize in cutting-edge technology to solve complex problems.</p>
    </div>
  );
};

export default About;
